import { rgba } from "polished";
import styled from "styled-components";
import { TitleMobileStyled } from "../../../../../base/text/title/views/mobile/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../styles/common/mixins/logical.styled.js";
export const MobileBlogFeed = styled.div.withConfig({
    displayName: "styled__MobileBlogFeed",
    componentId: "sc-94bb414a-0"
})`
	${FlexMixin({
    direction: 'column',
    justify: 'center'
})}
	margin: 0 auto;
	max-width: 1500px;
	position: relative;
	width: 100%;

	${TitleMobileStyled} {
		${FlexMixin({
    justify: 'center'
})};
	}
`;
export const MobileBlogList = styled.div.withConfig({
    displayName: "styled__MobileBlogList",
    componentId: "sc-94bb414a-1"
})`
	${FlexMixin({
    direction: 'column'
})}
	gap: 8px;
	background-color: ${({ theme  })=>theme.bodyBgColor};
`;
export const MobileBlogListSecondary = styled.div.withConfig({
    displayName: "styled__MobileBlogListSecondary",
    componentId: "sc-94bb414a-2"
})`
	${FlexMixin({
    direction: 'column'
})}
	gap: 8px;
	height: 100%;
	width: 100%;
`;
export const MobileBlogFeedFooter = styled.footer.withConfig({
    displayName: "styled__MobileBlogFeedFooter",
    componentId: "sc-94bb414a-3"
})`
	display: block;
	text-align: center;
	background-color: ${({ theme  })=>theme.bodyBgColor};
`;
export const MobileBlogFeedFooterDescription = styled.p.withConfig({
    displayName: "styled__MobileBlogFeedFooterDescription",
    componentId: "sc-94bb414a-4"
})`
	${FontMixin({
    size: 'base',
    height: 'large',
    weight: 'light'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
	margin: 24px 0 20px;
`;
export const MobileBlogFeedFooterLink = styled.a.withConfig({
    displayName: "styled__MobileBlogFeedFooterLink",
    componentId: "sc-94bb414a-5"
})`
	${BorderRadius({
    all: '4px'
})}
	${FontMixin({
    size: 'medium',
    height: 'medium',
    weight: 'medium'
})}
	background-color: ${({ theme  })=>theme.colors.white.base};
	border-color: ${({ theme  })=>theme.colors.primary.light};
	border-style: solid;
	border-width: 1px;
	color: ${({ theme  })=>theme.colors.primary.light};
	display: inline-block;
	padding: 8px 12px;
	margin: 12px 0 24px;
	text-transform: uppercase;
	transition: 0.4s;

	&:hover {
		color: ${({ theme  })=>theme.colors.white.base};
		background-color: ${({ theme  })=>rgba(theme.colors.primary.light ?? theme.colors.primary.base, 0.97)};
	}
`;

//# sourceMappingURL=styled.js.map